export default __webpack_public_path__ + "static/header_sponsor_2-3721a583d22ab5481354f0b87a9f79ef.svg";